// extracted by mini-css-extract-plugin
var _1 = "bpl__arrow-move-bottom__IPbp8";
var _2 = "bpl__arrow-move-right__gPrBb";
var _3 = "bpl__button__cgB4g";
var _4 = "bpl__button__m-arrow-on-hover-bottom__Sl3w4";
var _5 = "bpl__button__m-arrow-on-hover-right__CO1Q3";
export { _1 as "arrow-move-bottom", _2 as "arrow-move-right", _3 as "button", _4 as "button__m-arrow-on-hover-bottom", _5 as "button__m-arrow-on-hover-right" }
